import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const HomeFacedPixelIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_2022_13612)">
        <path d="M18.2508 46.9998H21.1255V38.3755H9.62549V46.9998H12.5001V41.2498H18.2508V46.9998Z" fill={fillColor || 'black'} />
        <path d="M35.5012 38.3755H29.7505V44.1255H35.5012V38.3755Z" fill={fillColor || 'black'} />
        <path d="M9.62513 9.62572H41.2505V6.75H6.75049V21.1257H9.62513V9.62572Z" fill={fillColor || 'black'} />
        <path
          d="M44.1254 23.9998H3.87464V3.87549H1V44.1255H3.87464V46.9998H6.74928V35.4998H41.2493V46.9998H44.1239V35.4998H46.9986V3.87549H44.1239V24.0012L44.1254 23.9998ZM44.1254 32.6255H38.3746V29.7498H35.5V32.6255H29.7493V29.7498H26.8746V32.6255H21.1239V29.7498H18.2493V32.6255H12.4986V29.7498H9.62391V32.6255H3.87464V26.8755H44.1254V32.6255Z"
          fill={fillColor || 'black'}
        />
        <path d="M44.1252 1H3.87451V3.87572H44.1252V1Z" fill={fillColor || 'black'} />
      </g>
      <defs>
        <clipPath id="clip0_2022_13612">
          <rect width="46" height="46" fill={fillColor || 'white'} transform="translate(1 1)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export { HomeFacedPixelIcon };
